import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useUsers } from '@/lib/queries';
import { UserForm } from '@/components/admin/user-form';

export function AdminUserEditPage() {
  const { id } = useParams();
  const users = useUsers();
  const row = users.data?.users.find((u) => u.id === id);

  return (
    <div className="container-narrow py-8 max-w-xl">
      <Button asChild variant="ghost" size="sm" className="mb-4">
        <Link to="/admin/utenti">
          <ArrowLeft className="h-4 w-4" /> Utenti
        </Link>
      </Button>
      <h1 className="font-serif text-2xl font-semibold mb-6">Modifica utente</h1>

      {users.isLoading ? (
        <p className="text-sm text-(--color-muted-foreground)">Caricamento…</p>
      ) : row ? (
        <UserForm
          userId={row.id}
          initial={{
            username: row.username,
            role: row.role,
            banned: row.banned,
            allowedFonti: row.allowedFonti,
            dataFrom: row.dataFrom,
            dataTo: row.dataTo,
          }}
        />
      ) : (
        <p className="text-sm text-(--color-destructive)">Utente non trovato.</p>
      )}
    </div>
  );
}
